export default "/fonts/vendor/@quasar/extras/fontawesome-v6/fa-v4compatibility.ttf?da94ef451f4969af06e6f5b36393459d";